<template>
<section>
  <b-card class="cissetting mb-1 sticky-top" id="userList-card">
    <b-row>
      <b-col>
        <div id="adminMenu" style="margin-left: 0rem;">
          <b-form-radio
            class="btn-radio"
            v-model="selectedAdminMenu"
            value="account"
            size=""
            button
            @change="adminMenuClick('account')"
            style="display: inline-block !important; margin-right: 1rem; min-width: 10rem;"
          >
            ACCOUNT
          </b-form-radio>
          <b-form-radio
            class="btn-radio"
            v-if="hasSuperAdminRole()"
            v-model="selectedAdminMenu"
            value="prices"
            size=""
            button
            @change="adminMenuClick('prices')"
            style="display: inline-block !important; margin-right: 1rem; min-width: 10rem;"
          >
            PRICES
          </b-form-radio>
          <b-form-radio
            class="btn-radio"
            v-model="selectedAdminMenu"
            value="users"
            size=""
            button
            @change="adminMenuClick('users')"
            style="display: inline-block !important; margin-right: 1rem; min-width: 10rem;"
          >
            USERS
          </b-form-radio>
          <b-form-radio
            class="btn-radio"
            v-if="hasSuperAdminRole()"
            v-model="selectedAdminMenu"
            value="seeds"
            size=""
            button
            @change="adminMenuClick('seeds')"
            style="display: inline-block !important; margin-right: 1rem; min-width: 10rem;"
          >
            SEEDS
          </b-form-radio>
          <b-form-radio
            class="btn-radio"
            v-if="hasSuperAdminRole()"
            v-model="selectedAdminMenu"
            value="keywords"
            size=""
            button
            @change="adminMenuClick('keywords')"
            style="display: inline-block !important; margin-right: 1rem; min-width: 10rem;"
          >
            KEYWORDS
          </b-form-radio>
          <b-form-radio
            class="btn-radio"
            v-if="hasSuperAdminRole()"
            v-model="selectedAdminMenu"
            value="synonyms"
            size=""
            button
            @change="adminMenuClick('synonyms')"
            style="display: inline-block !important; margin-right: 1rem; min-width: 10rem;"
          >
            SYNONYMS
          </b-form-radio>
          <b-form-radio
            class="btn-radio"
            v-if="hasSuperAdminRole()"
            v-model="selectedAdminMenu"
            value="uncategorized"
            size=""
            button
            @change="adminMenuClick('uncategorized')"
            style="display: inline-block !important; margin-right: 1rem; min-width: 10rem;"
          >
            UNCATEGORIZED
          </b-form-radio>
        </div>
      </b-col>
    </b-row>
  </b-card>




  <b-card class="cissetting mb-0">
    <div class="d-flex align-items-center justify-content-between mb-1">
      <div>
          <b-form-input
            v-model="searchQuery"
            placeholder="Search..."
            type="text"
          />
      </div>
      <div class="d-flex align-items-center">
        <div style="margin-right: 1rem;">
          {{this.now_mem_num}}/{{this.max_mem_num}}
        </div>
        <b-button
          v-if="hasSuperAdminRole() || hasAdminRole()"
          variant="primary"
          @click="inviteUser()"
        >
          Invite
        </b-button>
      </div>
    </div>

    <b-table
      ref="refUsersTable"
      responsive
      :items="fetchUsers"
      :fields="tableColumns"
      primary-key="id"
      show-empty
      empty-text="해당하는 키워드가 없습니다."
      class="position-relative mb-0"
    >
      <!-- Column: Account -->
      <template #cell(account)="data">
        <span class="text-nowrap">
          {{ data.item.account }}
        </span>
      </template>

      <!-- Column: Title -->
      <template #cell(name)="data">
        <span class="text-nowrap">
          {{ data.item.name }}
        </span>
      </template>

      <!-- Column: Email -->
      <template #cell(email)="data">
        <span class="text-nowrap">
          {{ data.item.email }}
        </span>
      </template>

      <!-- Column: Role -->
      <template #cell(role)="data">
        <span class="text-nowrap">
          {{ data.item.role.name }}
        </span>
      </template>

      <template #cell(actions)="data">
        <div class="text-nowrap">
          <feather-icon
            v-if="hasSuperAdminRole() || hasAdminRole()"
            icon="Edit2Icon"
            class="cursor-pointer mr-1"
            size="16"
            @click="updateUser(data.item)"
          />
          <feather-icon
            v-if="hasSuperAdminRole() || hasAdminRole()"
            icon="Trash2Icon"
            class="cursor-pointer"
            size="16"
            @click="deleteUser(data.item.id)"
          />
        </div>
      </template>
    </b-table>

    <b-row class="mt-1">
      <b-col
        cols="12"
        sm="6"
        class="d-flex align-items-center justify-content-center justify-content-sm-start"
      >
        <span class="text-muted">
          Showing {{ dataMeta.from }} to {{ dataMeta.to }} of
          {{ dataMeta.of }} entries
        </span>
        <b-form-group class="text-nowrap mb-md-0 ml-1">
          <b-form-select
            id="perPageSelect"
            v-model="perPage"
            size="sm"
            inline
            :options="perPageOptions"
          />
        </b-form-group>
      </b-col>
      <!-- Pagination -->
      <b-col
        cols="12"
        sm="6"
        class="d-flex align-items-center justify-content-center justify-content-sm-end"
      >
        <b-pagination
          v-model="currentPage"
          :total-rows="totalUsers"
          :per-page="perPage"
          first-number
          last-number
          prev-class="prev-item"
          next-class="next-item"
        >
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>
          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
        </b-pagination>
      </b-col>
    </b-row>

    <invite-user-modal 
      :refreshData="reFetchData"
    />
    <update-user-modal
      :updatingUser="updatingUser"
      :refreshData="reFetchData"
    />
  </b-card>
</section>
</template>

<script>
import {
  BCard,
  BCol,
  BRow,
  BCardBody,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BButton,
  BTable,
  BLink,
  BTooltip,
  BPagination,
  BFormRadio,
} from "bootstrap-vue";
import cisUsersList from "@/views/cis-settings/components/cisUsersList";
import InviteUserModal from "@/views/cis-settings/modal/InviteUserModal";
import UpdateUserModal from "@/views/cis-settings/modal/UpdateUserModal";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import vSelect from "vue-select";

import CISUserService from "@/services/cis-user.service";
import CISAccountService from "@/services/cis-account.service";

import useJwt from "@/auth/jwt/useJwt";

export default {
  name: "AdAccountUsers",
  components: {
    BCard,
    BCol,
    BRow,
    BCardBody,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BButton,
    BTable,
    BLink,
    BTooltip,
    BPagination,
    InviteUserModal,
    UpdateUserModal,
    vSelect,
    BFormRadio,
  },
  data() {
    return {
      updatingUser: null,
      selectedAdminMenu: "users",
      max_mem_num: 0,
      now_mem_num: 0,
    };
  },
  computed:{
    check_adminMenu() {
      return this.$store.getters.getSelectedAdminMenu
    }
  },
  watch: {
    check_adminMenu(value) {
      this.selectedAdminMenu = value
    }
  },
  methods: {
    async setMemNum(){
      var priceId =  useJwt.getUserData().priceId
      var adacctId = useJwt.getUserData().adacctId

      console.log('priceId : ', priceId)
      console.log('adacctId : ', adacctId)

      // setMaxMemNum by priceId
      const maxMemRes = await CISUserService.getMaxMemNum(priceId);
      if (maxMemRes.data.success) {
        console.log('maxMemRes.data.data')
        console.log(maxMemRes.data.data)
        this.max_mem_num = maxMemRes.data.data;        
      }

      // setNowMemNum by adacctId
      const nowMemRes = await CISUserService.getNowMemNum(adacctId);
      if (nowMemRes.data.success) {
        console.log('nowMemRes.data.data')
        console.log(nowMemRes.data.data)
        this.now_mem_num = nowMemRes.data.data;        
      }
    },

    adminMenuClick(mode) {      
      this.$store.dispatch('callAdminMenu', { adminMenu: mode })

      switch(mode) {
        case 'account':
          this.$router.push({ name: "cis-account" }).catch(() => {});
          break;
        case 'prices':
          this.$router.push({ name: "cis-prices" }).catch(() => {});
          break;
        case 'users':
          this.$router.push({ name: "cis-users" }).catch(() => {});
          break;
        case 'seeds':
          this.$router.push({ name: "cis-seeds" }).catch(() => {});
          break;
        case 'keywords':
          this.$router.push({ name: "cis-keywords" }).catch(() => {});
          break;
        case 'synonyms':
          this.$router.push({ name: "cis-synonyms" }).catch(() => {});
          break;
        case 'uncategorized':
          this.$router.push({ name: "cis-uncategorized" }).catch(() => {});
          break;
      }

      
    },

    
    deleteUser(id) {
      this.$swal({
        title: "Are you sure?",
        html: "You want to delete the user!<br>&nbsp;",
        icon: "warning",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
        padding: "1rem"
      }).then(async (result) => {
        if (result.isConfirmed) {
          const deleteResponse = await CISUserService.deleteUser({mbrSq: id});
          if (deleteResponse.status === 200) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Successfully deleted!",
                icon: "TrashIcon",
                variant: "success",
              },
            });
            this.reFetchData();
            this.setMemNum();
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message || "Unknown error",
                icon: "AlertCircleIcon",
                variant: "danger",
              },
            });
          }
        }
      });
    },
    updateUser(user) {
      this.updatingUser = user;
      this.$bvModal.show("update-user-modal");
    },

    inviteUser(){
      if(this.now_mem_num < this.max_mem_num){
        this.$bvModal.show("invite-user-modal");
      }else{
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Limited Max Memeber",
            icon: "AlertCircleIcon",
            variant: "danger",
          },
        });
        this.$bvModal.hide("invite-user-modal");
      }
      
    }


  },
  setup() {
    const {
      fetchUsers,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUsersTable,

      statusFilter,

      reFetchData,
    } = cisUsersList();

    return {
      fetchUsers,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUsersTable,

      statusFilter,

      reFetchData,
    };
  },
  created() {
    this.setMemNum();
  },
};
</script>

<style lang="scss">

.mb-1 .sticky-top{
  align-self: flex-start;
}

.cissetting .card-body {
    padding: 1.0rem;
  }

#adminMenu .btn-radio .btn-secondary {
  background-color: #4E86FF !important;
  border-color: #4E86FF !important;
  box-shadow: none;
}


#adminMenu .btn-radio .btn-secondary.active {
  background-color: #1951dc !important;
  border-color: #1c5cff !important;
  // box-shadow: 0 6px 30px -6px #002896;
  // font-weight: 600;
  // font-size: 1.3rem;
}


.adaccount-select {
  font-size: large;

  .vs__dropdown-toggle {
    height: 80px;
  }

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}

.account-select .vs__dropdown-menu {
  padding: 0px 0px 0px 0px;
}

</style>
